import { render } from "./Form.vue?vue&type=template&id=5be3b680&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=5be3b680&lang=scss&scoped=true"

import exportComponent from "/home/nboq9356/fdes-meiser.ailoop.io/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be3b680"]])

export default __exports__